const AddressType = {
  mailing: 'mailing',
  permanent: 'permanent'
};

export default AddressType;
